import { cn } from "@babybjorn/ui";
import type { FC, HTMLAttributes } from "react";
import Icon from "../../../../general/Icon";
import Link from "../../../../general/Link";
import * as s from "./CartIndicator.module.scss";

type CartIndicatorProps = HTMLAttributes<HTMLButtonElement> & {
	itemCount: number;
	href?: string;
};

const CartIndicator: FC<CartIndicatorProps> = ({ itemCount, href }) => (
	<Link className={cn(s.special, { "pointer-events-none": !href })} href={href}>
		<Icon icon={href ? "cart" : "edit"} />
		<span>{itemCount}</span>
	</Link>
);

export default CartIndicator;
